import parseHydraDocumentation from "@api-platform/api-doc-parser/lib/hydra/parseHydraDocumentation";
import React from "react";
import { Redirect } from "react-router-dom";
import fetchOk from "./utils/fetchOk";

const fetchHeaders = {
	Authorization: `Bearer ${window.localStorage.getItem("token")}`,
	"X-HOTEL": process.env.REACT_APP_HOTEL,
};

let documentation = null;

// contentUrls are now absolute object-storage URLs; only prefix a value that is
// still relative, otherwise we produce "https://api...https://..." double URLs.
const resolveMediaUrl = (entrypoint, url) => {
	if (!url) {
		return null;
	}
	return /^https?:\/\//i.test(url) ? url : `${entrypoint}${url}`;
};

const api = (entrypoint) =>
	parseHydraDocumentation(entrypoint, {
		headers: new Headers(fetchHeaders),
	}).then(
		({ api }) => {
			api.resources.map((resource) => {
				resource.fields.map((field) => {
					if ("image" === field.name) {
						field.denormalizeData = (value) => {
							// Handle case where value is a media object reference string
							if (
								typeof value === "string" &&
								value.startsWith("/media_objects/")
							) {
								// For media object references, we need to fetch the media object
								// to get its contentUrl. Since denormalizeData should be synchronous,
								// we'll return a promise that resolves to the correct structure
								return fetch(`${entrypoint}${value}`, {
									headers: new Headers(fetchHeaders),
								})
									.then((response) => response.json())
									.then((mediaObject) => ({
										original: value,
										src: resolveMediaUrl(entrypoint, mediaObject.contentUrl),
									}))
									.catch(() => ({
										original: value,
										src: null,
									}));
							}
							// Handle case where value is a full media object with contentUrl
							return {
								original: value,
								src: resolveMediaUrl(entrypoint, value && value.contentUrl),
							};
						};

						field.normalizeData = (value) => {
							if (value && value.rawFile instanceof File) {
								const body = new FormData();
								body.append("file", value.rawFile);

								return fetchOk(`${entrypoint}/media_objects/upload`, {
									body,
									method: "POST",
									headers: fetchHeaders,
								})
									.then((response) => response.json())
									.then((value) => `/media_objects/${value.id}`);
							}
							if (value) {
								return value.original ? value.original : value.src;
							}
							return null;
						};
					} else {
						field.normalizeData = (value) => {
							if (value === "") {
								return null;
							}
							return value;
						};
					}
					return field;
				});
				return resource;
			});
			return { api };
		},
		(result) => {
			switch (result.status) {
				case 401:
					return Promise.resolve({
						api: result.api,
						customRoutes: [
							{
								props: {
									path: "/",
									render: () => <Redirect to="/login" />,
								},
							},
						],
					});

				default:
					return Promise.reject(result);
			}
		},
	);

export default () => {
	if (!documentation) {
		documentation = api(process.env.REACT_APP_API_ENTRYPOINT);
	}
	return documentation;
};
